const LEGACY_FINANCE_COLUMN_KEYS = [
  "sellerEarningLocal",
  "revenueUsd",
  "effectiveTaxUsd",
  "warehouseCostUsd",
  "productCostUsd",
] as const;

/** Kar/zarar tablosu kolon anahtarları (actions hariç sürüklenebilir). */
const MERGED_INTO_ORDER_COLUMN_KEYS = ["warehouseOrderNo", "purchaseDate"] as const;

export const DEFAULT_PNL_COLUMN_KEYS = [
  "order",
  "market",
  "financeStack",
  "totalCostUsd",
  "profitUsd",
  "profitPercent",
  "shipmentStatus",
  "trackingNumber",
  "shippingAddress",
  "orderStatus",
] as const;

export type PnlColumnKey = (typeof DEFAULT_PNL_COLUMN_KEYS)[number] | "actions";

const STORAGE_PREFIX = "acmPlColumnOrder:";

function migrateMergedOrderColumns(stored: string[]): string[] {
  return stored.filter(
    (key) =>
      key !== "actions" &&
      !MERGED_INTO_ORDER_COLUMN_KEYS.includes(key as (typeof MERGED_INTO_ORDER_COLUMN_KEYS)[number])
  );
}

function migrateLegacyFinanceColumns(stored: string[]): string[] {
  const result: string[] = [];
  let financeInserted = false;
  for (const key of stored) {
    if (key === "actions") {
      continue;
    }
    if (key === "financeStack" || LEGACY_FINANCE_COLUMN_KEYS.includes(key as (typeof LEGACY_FINANCE_COLUMN_KEYS)[number])) {
      if (!financeInserted) {
        result.push("financeStack");
        financeInserted = true;
      }
      continue;
    }
    if (!result.includes(key)) {
      result.push(key);
    }
  }
  return result;
}

export function mergePnlColumnOrder(stored: string[]): string[] {
  const migrated = migrateLegacyFinanceColumns(migrateMergedOrderColumns(stored));
  const defaults = [...DEFAULT_PNL_COLUMN_KEYS];
  const valid = new Set<string>(defaults);
  const result: string[] = [];
  for (const key of migrated) {
    if (valid.has(key) && !result.includes(key)) {
      result.push(key);
    }
  }
  for (const key of defaults) {
    if (!result.includes(key)) {
      result.push(key);
    }
  }
  return result;
}

export function loadPnlColumnOrder(userId: string | null): string[] {
  if (!userId) {
    return [...DEFAULT_PNL_COLUMN_KEYS];
  }
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + userId);
    if (!raw) {
      return [...DEFAULT_PNL_COLUMN_KEYS];
    }
    const parsed = JSON.parse(raw) as string[];
    if (!Array.isArray(parsed)) {
      return [...DEFAULT_PNL_COLUMN_KEYS];
    }
    return mergePnlColumnOrder(parsed);
  } catch {
    return [...DEFAULT_PNL_COLUMN_KEYS];
  }
}

export function savePnlColumnOrder(userId: string | null, keys: string[]): void {
  if (!userId) {
    return;
  }
  const toSave = keys.filter((k) => k !== "actions");
  localStorage.setItem(STORAGE_PREFIX + userId, JSON.stringify(toSave));
}

export function reorderPnlColumns(order: string[], fromKey: string, toKey: string): string[] {
  if (fromKey === toKey || fromKey === "actions" || toKey === "actions") {
    return order;
  }
  const next = order.filter((k) => k !== fromKey);
  const toIndex = next.indexOf(toKey);
  if (toIndex < 0) {
    return order;
  }
  next.splice(toIndex, 0, fromKey);
  return next;
}
